import State from './State';

/**
 * Getters are computed values based on state. They are cached until
 * their dependencies change.
 *
 * @see https://vuex.vuejs.org/guide/getters.html
 *
 * @class Getters
 * @package Store/Module/VersionHistory
 * @project ChalkySticks App
 */
const getters = {
	/**
	 * Check if this is a first launch ever (no version history)
	 *
	 * @param State state
	 * @return boolean
	 */
	isFirstLaunchEver(state: typeof State): boolean {
		return state.seenVersions.length === 0;
	},

	/**
	 * Get the last seen version before current
	 *
	 * @param State state
	 * @return string | null
	 */
	lastSeenVersion(state: typeof State): string | null {
		return state.lastSeenVersion;
	},

	/**
	 * Get all versions the user has seen
	 *
	 * @param State state
	 * @return string[]
	 */
	seenVersions(state: typeof State): string[] {
		return state.seenVersions;
	},

	/**
	 * Get the version first seen dates map
	 *
	 * @param State state
	 * @return Record<string, number>
	 */
	versionFirstSeenDates(state: typeof State): Record<string, number> {
		return state.versionFirstSeenDates;
	},
};

export default getters;
